import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Mail, MessageCircle, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";

export default function Confirmation() {
  const { t, localizePath } = useI18n();
  const navigate = useNavigate();
  const leadId = sessionStorage.getItem("sm_lead_id") || "—";

  const steps = [
    { icon: Sparkles, k: 1 },
    { icon: CheckCircle2, k: 2 },
    { icon: Mail, k: 3 },
  ];

  return (
    <div data-testid="confirmation-page" className="min-h-screen pt-24 pb-20 bg-sand grain relative">
      <div className="max-w-3xl mx-auto px-5 lg:px-0">
        <div className="text-center animate-fade-up">
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-navy text-white">
            <CheckCircle2 className="h-8 w-8 text-gold" />
          </span>
          <h1 className="mt-7 font-serif text-4xl lg:text-5xl text-navy tracking-tight leading-tight">
            {t("confirm.title")}
          </h1>
          <p className="mt-5 max-w-xl mx-auto text-ink leading-relaxed">{t("confirm.sub")}</p>
          <p className="mt-4 text-xs uppercase tracking-[0.22em] text-ink">
            {t("confirm.ref")}: <span data-testid="lead-ref" className="text-navy font-semibold">{leadId.slice(0, 8).toUpperCase()}</span>
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-3 gap-4">
          {steps.map((s, i) => (
            <div
              key={i}
              data-testid={`confirm-step-${i + 1}`}
              className="rounded-2xl bg-white border border-[#E2E8F0] p-6"
              style={{ animationDelay: `${0.1 * (i + 1)}s` }}
            >
              <div className="flex items-center gap-3">
                <span className="h-9 w-9 rounded-full bg-sand flex items-center justify-center">
                  <s.icon className="h-4 w-4 text-navy" />
                </span>
                <span className="label-eyebrow">0{s.k}</span>
              </div>
              <p className="mt-5 font-serif text-xl text-navy">{t(`confirm.step${s.k}`)}</p>
              <p className="mt-2 text-sm text-ink leading-relaxed">{t(`confirm.step${s.k}Desc`)}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button
            data-testid="back-home"
            onClick={() => navigate(localizePath("/"))}
            className="bg-navy text-white hover:bg-[#06101f] rounded-full h-11 px-7"
          >
            {t("confirm.home")} <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
}
